import { SICK_DAY_REASONS_TO_NEW_SUBTYPE } from 'domain/shared/leave';
import { formatLeaveTypeWithSubType } from 'domain/people/leave/shared/leaveTypeDisplay';
import { FieldProps, useFieldHelper, TextField } from 'framework/ui/field';
import type { Data } from 'framework/types';

type LeaveTypeFieldProps = FieldProps & {
  subType?: string | null;
  sickDayReason?: keyof typeof SICK_DAY_REASONS_TO_NEW_SUBTYPE | null;
};

const LeaveTypeField = ({
  value: inputValue,
  source,
  label,
  subType: subTypeProp,
  sickDayReason: sickDayReasonProp,
}: LeaveTypeFieldProps) => {
  const { getValue, getData, getLabel } = useFieldHelper({ value: inputValue, source, label });

  const type = (inputValue ?? getValue?.()) as string | undefined;
  const data = getData?.() as Data | undefined;

  const subType =
    subTypeProp !== undefined ? subTypeProp : (data?.getValueBySource('subType') as string | null | undefined);

  const sickDayReason =
    sickDayReasonProp !== undefined
      ? sickDayReasonProp
      : (data?.getValueBySource('sickDayReason') as keyof typeof SICK_DAY_REASONS_TO_NEW_SUBTYPE | null | undefined);

  const display = formatLeaveTypeWithSubType({
    type,
    subType: subType ?? null,
    sickDayReason: sickDayReason ?? null,
  });

  return <TextField value={display} label={getLabel()} source={source} />;
};

export default LeaveTypeField;
